module.exports = __webpack_public_path__ + "static/image/logo-family/logo_cartoon@3x.png?ea7a250a";